import { useState } from 'react';
import { Box, Typography, Link } from '@mui/material';

interface CollapsibleTextProps {
  text: string;
  maxLength?: number;
}

function CollapsibleText({ text, maxLength = 100 }: CollapsibleTextProps) {
  const [expanded, setExpanded] = useState(false);

  const shouldCollapse = text.length > maxLength;
  const displayText = expanded || !shouldCollapse ? text : `${text.slice(0, maxLength)}...`;

  return (
    <Box>
      <Typography
        variant="body2"
        sx={{
          wordBreak: 'break-word',
          whiteSpace: 'pre-wrap',
          color: '#6C6D76',
          fontSize: '0.75rem',
          lineHeight: 1.4,
        }}
      >
        {displayText}
      </Typography>
      {shouldCollapse && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          component="button"
          variant="body2"
          onClick={() => setExpanded(!expanded)}
          sx={{
            fontSize: '0.7rem',
            mt: 0.5,
            cursor: 'pointer',
          }}
        >
          {expanded ? 'Show less' : 'Show more'}
        </Link>
      )}
    </Box>
  );
}

export default CollapsibleText;
